var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M15.2426 20.2426L11 15.9999L15.2426 11.7573","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M11 16H21","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

BackArrow.defaultProps = {"className":"stroke-current text-secondary-900 w-7 h-7","viewBox":"0 0 32 32","fill":"none"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
